import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { Provider } from "react-redux";

import Candle from "./container/Candle";

import "./assets/css/index.css";
import "./assets/css/font.css";
import "./assets/css/ReactToastify.min.css";
import { store } from "./sotre/redux/store";
import AdminToastContainer from "./components/common/toast/AdminToastContainer";

import { removeRefreshMarker } from "./services/app-update/appUpdate";

removeRefreshMarker();

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <Provider store={store}>
        <Candle />
      </Provider>
    </BrowserRouter>
    <AdminToastContainer />
  </React.StrictMode>
);
